import {
  grey100,
  greyA100,
  lightBlue900,
  sunflowerYellowGradient,
  red500,
  blue100,
  white,
  sunflowerYellow,
  lightGrey,
  grey900,
} from './colors';
import common from './colors.common';

const flights = {
  roundTripBanner: {
    descriptionBg: '#1976d2',
    descriptionText: white,
    callToActionBg: greyA100,
    callToActionText: common.peacockBlue,
  },

  flightDetails: {
    title: common.textSeconday,
    text: common.textSeconday,
    dividerYellow: sunflowerYellow,
    dividerGrey: lightGrey,
  },

  flightItem: {
    divider: grey100,
    lightBackground: greyA100,
    lightBlue: lightBlue900,
    alert: red500,
    selected: sunflowerYellowGradient,
    focus: blue100,
    text: grey900,
  },
};

export default flights;
